export default __webpack_public_path__ + "static/media/sinc.44f9b83c.png";